import { render, staticRenderFns } from "./VendorMap.vue?vue&type=template&id=782b8e54"
import script from "./VendorMap.vue?vue&type=script&lang=js"
export * from "./VendorMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports